export default [{
  path: 'wasteContractList',
  name: 'wasteContractList',
  component: function component() {
    return import('@/views/recoveryManage/recoveryContractManage/index');
  }
}, {
  path: 'recoveryContractAdd',
  name: 'recoveryContractAdd',
  component: function component() {
    return import('@/views/recoveryManage/recoveryContractManage/saveOrUpdate');
  }
}, {
  path: 'recoveryContractUpdate',
  name: 'recoveryContractUpdate',
  component: function component() {
    return import('@/views/recoveryManage/recoveryContractManage/saveOrUpdate');
  }
}];